import styled from 'styled-components';

export const Value = styled.p<{ $color: string }>`
  color: ${(props) => props.$color};
  margin: 0;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  font-size: 16px;
`;
